import React, { useState, useRef } from "react"
import SpinnerControls from './spinnerControls'
//import PhotoSwipe from 'react-photoswipe'


const Spinner = ({frames}) => {

    const images_on  = frames.on.nodes.map( (f) => f.childImageSharp.webp ),
          images_off = frames.off.nodes.map( (f) => f.childImageSharp.webp ),
          imgW = images_on[0].width,
          sides = images_on.length,
          sensitivity = 75, // pixels 
          autoplayPeriod = 4000 // milliseconds

    console.assert(images_on.length === images_off.length, 
                "On and off images must have equal number of sides")

    // scale sensitivity by image size
    // (if image is downscaled, sensitivity should be smaller)
    const imageRef = useRef(null),
          scale = imageRef.current
                    ? (imageRef.current.clientWidth) / imgW
                    : 1,
          moveThreshold = sensitivity * scale


    // dragging: -1 if not dragging
    // else x value of drag starting position
    const [dragging, setDragging] = useState(-1),
          [imageIndex, setImageIndex] = useState(0)


    const handleMouseDown = (event) => {
        setDragging(event.clientX)

        autoplay && setAutoplay(false)
    }


    const handleTouchStart = (event) => 
        setDragging(event.touches[0].clientX)


    const handleMouseUp = () =>
        setDragging(-1)


    const shiftLeft = (mouseX) => {
        let prevIndex = imageIndex - 1
        if (prevIndex < 0) 
            prevIndex = sides - 1

        setDragging(mouseX)
        setImageIndex(prevIndex)
    }

    const shiftRight = (mouseX) => {
        let nextIndex = imageIndex + 1
        if (nextIndex >= sides) 
            nextIndex = 0

        setDragging(mouseX)
        setImageIndex(nextIndex)
    }


    const handleMouseMove = (event) => {

        let mouseX = getMouseX(event)

        if (dragging !== -1) {
            let distance = mouseX - dragging
            if (distance > moveThreshold) 
                shiftRight(mouseX)
            else if(distance < -moveThreshold)
                shiftLeft(mouseX)
        }
    }


    const getMouseX = (event) => {

        // Using touch device
        if(event._reactName === "onTouchMove")
            return event.touches[0].clientX

        // Using mouse
        if(event._reactName === "onMouseMove")
            return event.clientX

        // Should never happen
        return -1
    }


    const [isLit, setIsLit] = useState(true),
          [autoplay, setAutoplay] = useState(true)
          //[pswpOpen, setPswpOpen] = useState(false)


    const rotate = () => shiftRight(-1)




    // Preload image in order they are likely to be displayed in 
    const preloadOrder = (xs) => {

        if (!xs) return []

        var ordered = [xs[0]]

        for(let i = 1; i <= Math.floor(xs.length / 2); i++) {
            ordered.push(xs[i])
            if (i !== xs.length - i)
                ordered.push(xs[xs.length - i])
        }

        console.assert(ordered.length === xs.length)

        return ordered
    }

    // Preload off images when off button is hovered
    const [hovered, setHovered] = useState(false)

    const preload = {
        on: preloadOrder(images_on).map( (img, index) => 
                <link rel="preload" as="image" href={img.src} key={`on${index}`} />
            ),
        off: preloadOrder(images_off).map( (img, index) => 
                <link rel="preload" as="image" href={img.src} key={`on${index}`} />
             )
    }
    


    const imgSource = isLit
                        ? images_on[imageIndex].src
                        : images_off[imageIndex].src

    return (
        <div style={{margin: "auto"}}>
            <img 
                ref={imageRef}
                src={imgSource}
                alt={`360 lamp view ${imageIndex}`}
                draggable="false" 
                onMouseDown={handleMouseDown}
                onTouchStart={handleTouchStart}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
                onTouchMove={handleMouseMove}
                onMouseLeave={handleMouseUp}
                onKeyPress={() => shiftRight(-1)}
                tabIndex={0}
                style={{
                    width: "100%",
                    height: "auto",
                    aspectRatio: "2/3",
                    margin: "auto",
                    display: "block",
                    cursor: dragging === -1 
                                ? "grab"
                                : "grabbing",
                }}
            />
            <SpinnerControls 
                params={{
                    imgW,
                    isLit,
                    setIsLit,
                    autoplay,
                    setAutoplay,
                    setHovered,
                    rotate,
                    autoplayPeriod
                }}
            />
        { // Preload images
            hovered 
                ? preload.on.concat(preload.off)
                : preload.on
        }
        </div>
    )
}


export default Spinner;